import React, { Component } from "react"
import { inject, observer } from "mobx-react"
import styled from "styled-components"

import Input from "~/components/Form/LandingInput"
import Spacer from "~/components/Spacer"
import FormError from "~/components/Form/ErrorText"
import withTranslations from "~/components/_hocs/withTranslations"
import InputTitle from "./InputTitle"

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
`

@inject((all) => ({
  validateDisplayMessage: all.store.trafficLookup.validateDisplayMessage,
  changePlateNumber: all.store.trafficLookup.changePlateNumber,
  plateNumber: all.store.trafficLookup.plateNumber,
}))
@observer
class PlateNumber extends Component {
  handleChange = (e) => {
    this.props.changePlateNumber(e.target.value)
  }

  render() {
    const plateNumberError = this.props.validateDisplayMessage("plateNumber")
    return (
      <Wrap>
        <InputTitle>
          {this.props.translate("label")}
          <Spacer direction="width" mobile={11} desktop={11} />
        </InputTitle>
        <Spacer desktop={16} mobile={4} />
        <Input
          placeholder={this.props.translate("placeholder")}
          onChange={this.handleChange}
          value={this.props.plateNumber}
          error={plateNumberError}
          maxLength={9}
        />
        <FormError error={plateNumberError} />
      </Wrap>
    )
  }
}

export default withTranslations(PlateNumber, "form.traffic.plateNumber")
